import { formatUrl } from 'frontend-utils/utils/url/format-url';
import { openUrl } from 'frontend-utils/utils/url/open-url';

export default function requestFeatureAccess(
  host: string,
  params: Record<string, string>,
): void {
  openUrl(
    formatUrl(
      `${host}/admin/user_permissions/temporary_feature_flag_request/`,
      params,
    ),
    true,
  );
}
